export const modalWidth = "437px;";
